'use strict';

angular.module('app.networks', [])
.controller('networkManagementCtrl', ['$scope', '$modal', '$http', 'adminService', 'networkManagementService', 
    function ($scope, $modal, $http, adminService, networkManagementService) {
    
    $scope.preLoaded = false;
    // $scope.loaded = false;
    $scope.InfluencersAll = [];
    $scope.currentPage = 1;
    $scope.delCurrentPage = 1;
    $scope.pageSize = 25;
    $scope.fieldName = null;
    $scope.sortField = null;
    $scope.order = false;
    $scope.tempOrder = false;
    $scope.Header = ["","","","","",""];
    $scope.iconName = "";
    $scope.searchNetwork = null;
    $scope.hasValue = null;
    $scope.delFlag = 0;
    $scope.searchNetworkFinalString = null;    

    //server-side
    var count = 0;
    $scope.preLoadData = function(hasValue, flag){
        count = count + 1;
        if(hasValue == null){
            var params = {
                searchNetwork: $scope.searchNetworkFinalString,
                pageNo: $scope.currentPage,
                sortByColumn: $scope.sortField,
                sortType: $scope.order,
                delFlag: flag
            }
            $scope.sendHttpPOST(params, true);
        }
        
        if(count == 2){
            $scope.preLoaded = true;
        }
       
    }

    $scope.sendHttpPOST = function(params, loader){
        networkManagementService.searchNetworks(params, loader)
            .then(function(response) {
                if(params.delFlag == 0){
                    $scope.networks = response.data;
                    $scope.networkNumber = response.totalRow;
                    $scope.number = response.totalRow;
                    $scope.pagination();
                }
                if(params.delFlag == 1){
                    $scope.delNetworks = response.data;
                    $scope.delNetworkNumber = response.totalRow;
                    $scope.number = response.totalRow;
                    $scope.pagination();
                }
            }, function(response) {
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = response.message;
            })
    }

    if(!$scope.preLoaded){
        $scope.preLoadData($scope.hasValue, 0);
        $scope.preLoadData($scope.hasValue, 1);
    }

    $scope.sort = function(fieldname){
        if($scope.fieldName != fieldname){
            $scope.fieldName = fieldname;
            $scope.tempOrder = $scope.order;
            $scope.order = $scope.order;
        }
        if($scope.fieldName == fieldname){
            $scope.tempOrder = $scope.order;
            $scope.order = !$scope.order;
        }
        if(fieldname == "networkName"){
            $scope.sortField = "name";
            $scope.delFlag = 0;
        }
        if(fieldname == "delNetworkName"){
            $scope.sortField = "name";
            $scope.delFlag = 1;
        }
        if(fieldname == "networkID"){
            $scope.sortField = "id";
            $scope.delFlag = 0;
        }
        if(fieldname == "delNetworkID"){
            $scope.sortField = "id";
            $scope.delFlag = 1;
        }
        if(fieldname == "country"){
            $scope.sortField = "country_id";
            $scope.delFlag = 0;
        }
        if(fieldname == "delCountry"){
            $scope.sortField = "country_id";
            $scope.delFlag = 1;
        }
        if($scope.tempOrder == true){
            $scope.iconName = "glyphicon glyphicon-chevron-up";
        } else{
            $scope.iconName = "glyphicon glyphicon-chevron-down";
        }
        if($scope.fieldName === 'networkName')
        {
            $scope.Header[0] = $scope.iconName;
            $scope.Header[1] = null;
            $scope.Header[2] = null;
            $scope.Header[3] = null;
            $scope.Header[4] = null;
            $scope.Header[5] = null;
        }
        if($scope.fieldName === 'networkID')
        {
            $scope.Header[0] = null;
            $scope.Header[1] = $scope.iconName;
            $scope.Header[2] = null;
            $scope.Header[3] = null;
            $scope.Header[4] = null;
            $scope.Header[5] = null;
        }
        if($scope.fieldName === 'country')
        {
            $scope.Header[0] = null;
            $scope.Header[1] = null;
            $scope.Header[2] = $scope.iconName;
            $scope.Header[3] = null;
            $scope.Header[4] = null;
            $scope.Header[5] = null;
        }
        if($scope.fieldName === 'delNetworkName')
        {
            $scope.Header[0] = null;
            $scope.Header[1] = null;
            $scope.Header[2] = null;
            $scope.Header[3] = $scope.iconName;
            $scope.Header[4] = null;
            $scope.Header[5] = null;
        }
        if($scope.fieldName === 'delNetworkID')
        {
            $scope.Header[0] = null;
            $scope.Header[1] = null;
            $scope.Header[2] = null;
            $scope.Header[3] = null;
            $scope.Header[4] = $scope.iconName;
            $scope.Header[5] = null;
        }
        if($scope.fieldName === 'delCountry')
        {
            $scope.Header[0] = null;
            $scope.Header[1] = null;
            $scope.Header[2] = null;
            $scope.Header[3] = null;
            $scope.Header[4] = null;
            $scope.Header[5] = $scope.iconName;
        }
        if ($scope.fieldName === 'networkName' || $scope.fieldName === 'networkID' || $scope.fieldName === 'country') {
            if($scope.searchNetworkString !=null){
                $scope.searchNetworkFinalString = $scope.searchNetworkString;
            } else{
                $scope.searchNetworkFinalString = null;
            }
        } else if ($scope.fieldName === 'delNetworkName' || $scope.fieldName === 'delNetworkID' || $scope.fieldName === 'delCountry') {
            if($scope.searchDelNetworkString !=null){
                $scope.searchNetworkFinalString = $scope.searchDelNetworkString;
            } else{
                $scope.searchNetworkFinalString = null;
            }
        }            
        var params = {
            searchNetwork: $scope.searchNetworkFinalString,
            pageNo: 1,
            sortByColumn: $scope.sortField,
            sortType: $scope.tempOrder,
            delFlag: $scope.delFlag           
        }

        $scope.sendHttpPOST(params, true);         
    }
    //End of pagination server-side

    $scope.pagination = function(){
        $scope.pages = adminService.pagination($scope.number, $scope.pageSize);
    };

    $scope.updatePage = function(val,flag){
        $scope.currentPage = val;
        var params = {
            searchNetwork: $scope.searchNetworkFinalString,
            pageNo: $scope.currentPage,
            sortByColumn: $scope.sortField,
            sortType: $scope.tempOrder,
            delFlag: flag
       } 

       $scope.sendHttpPOST(params, true);
    }

    $scope.searchNetwork = function(flag){
        if(flag == 0){
            $scope.searchNetworkFinalString = $scope.searchNetworkString;
        } else if(flag == 1){
            $scope.searchNetworkFinalString = $scope.searchDelNetworkString;
        }
        var params = {
            searchNetwork: $scope.searchNetworkFinalString,
            pageNo: 1,
            sortByColumn: $scope.sortField,
            sortType: $scope.order,
            delFlag: flag           
        }

        $scope.currentPage = 1;
        $scope.sendHttpPOST(params, true);        
    }

    $scope.newNetworkModalHandler = function () {
        var modalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/admin/networkManagement/addNewNetwork/addNewNetwork.html?app_v=deployDate',
            controller: 'addNewNetworkCtrl'
        });

        $scope.modalInstance = modalInstance;
    }

    $scope.NetworkDetails = function (index) {
        var modalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/admin/networkManagement/networkDetail/networkDetail.html?app_v=deployDate',
            controller: 'networkDetailCtrl'
        });
        $scope.modalInstance = modalInstance;
        $scope.index = index;
        // $scope.flag = flag;
    }   
}])

